
// header class add
 $(window).on("scroll", function() {
     if($(window).scrollTop() > 50) {
         $("header").addClass("newheader");
     } else {
        $("header").removeClass("newheader");
     }
 });


 // click to top
$(document).ready(function(){
   "use strict";
  var offSetTop = 100;
  var $scrollToTopButton = $('.scrollToTop');
   //Check to see if the window is top if not then display button
   $(window).scroll(function(){
      if ($(this).scrollTop() > offSetTop) {
         $scrollToTopButton.fadeIn();
      } else {
         $scrollToTopButton.fadeOut();
      }
   });
   
   //Click event to scroll to top
   $scrollToTopButton.click(function(){
      $('html, body').animate({scrollTop : 0},800);
      return false;
   });
   
});



// $(document).ready(function () {
//     // By default, open the first <li>
//     $('.tab-link:first').addClass('active');
//     $('.tab-link:first p').css('opacity', '1').slideDown(300);

//     $('.tab-link').click(function () {
//       const $this = $(this);
//       const $p = $this.find('p');

//       // If the clicked <li> is already active, do nothing
//       if ($this.hasClass('active')) {
//         return;
//       }

//       // Otherwise, close all other <li> <p> tags and open the clicked one with slideDown
//       $('.tab-link').removeClass('active');
//       $('.tabs .tab-link p').stop(true, true).slideUp(0).css('opacity', '0');

//       // Open the clicked <li> <p> tag with slideDown
//       $this.addClass('active');
//       $p.stop(true, true).slideDown(300).css('opacity', '1');
//     });
//   });

// $('.tabs .tab-link').click(function(){
//    getNum = $(this).index() + 1;
//    $('.content-wrapper .tab-content').css('display','none');
//    if( getNum < 10 ) {
//       $('.content-wrapper .img0' + getNum ).css('display','block');
//    } else {
//       $('.content-wrapper .img' + getNum ).css('display','block');
//    }
// });


$(document).ready(function () {
    // Initialize the first tab as active
    $('.tab-link:first').addClass('active');
    
    // Show the <p> tag for the first tab
    $('.tab-link:first p').css('opacity', '1').stop(true, true).slideDown(300);

    // Function to change the active tab and show/hide content
    $('.tab-link').click(function () {
        const $this = $(this);
        const $p = $this.find('p');
        const currentTabIndex = $this.index() + 1;

        // If the clicked tab is already active, do nothing
        if ($this.hasClass('active')) {
            return;
        }

        // Otherwise, close all other <li> <p> tags and open the clicked one with slideDown
        $('.tab-link').removeClass('active');
        $('.tabs .tab-link p').stop(true, true).slideUp(0).css('opacity', '0');

        // Open the clicked <li> <p> tag with slideDown
        $this.addClass('active');
        $p.stop(true, true).slideDown(2000).css('opacity', '1');

        // Show the correct tab content
        $('.content-wrapper .tab-content').hide();
        if (currentTabIndex < 10) {
            $('.content-wrapper .img0' + currentTabIndex).fadeIn();
        } else {
            $('.content-wrapper .img' + currentTabIndex).fadeIn();
        }

        // Reset the progress bar width for the active tab
        $('.tab-link').eq(currentTabIndex - 1).find(':after').css('width', '100%');
    });

    // Progress bar animation for tab changes
    let tabIndex = 1;
    let lastIndex = 0; // Variable to keep track of the last active tab index

    // Function to change the active tab every 3 seconds
    function changeTab() {
        // Remove the active class from the previous tab
        $('.tab-link').removeClass('active');
        
        // Add the active class to the current tab
        $('.tab-link').eq(tabIndex - 1).addClass('active');
        
        // Set the progress bar width of the previous tab to 100% (to not reset it to 0)
        $('.tab-link').eq(lastIndex).find(':after').css('width', '100%');

        // Show the current tab image
        $('.content-wrapper .tab-content').hide();
        $('.content-wrapper .img0' + tabIndex).fadeIn();

        // Trigger progress bar animation (increase width to 100%)
        $('.tab-link').eq(tabIndex - 1).find(':after').css('width', '100%');

        // Show the <p> tag for the current tab with slideDown
        $('.tab-link').eq(tabIndex - 1).find('p').stop(true, true).slideDown(2000).css('opacity', '1');

        // Update last index
        lastIndex = tabIndex - 1;

        // Increment the tab index and loop it after 6
        tabIndex = tabIndex < 6 ? tabIndex + 1 : 1;
    }

    // Change the image every 3 seconds
    setInterval(changeTab, 20000);

    // Initial image change
    changeTab();
});


// mushrom slider

jQuery(document).ready(function () {
   jQuery('.mushroom-slider').owlCarousel({
      items:5,
      loop:true,
      margin:30,
      nav:false,
      dots:false,
      autoplay: true,
      slideTransition: 'linear',
      autoplayTimeout: 3000,
      autoplaySpeed: 3000,
      autoplayHoverPause: true,
      responsive:{
          0:{
              items:2
          },
          600:{
              items:4
          },
          1000:{
              items:5
          }
      }
   });
   $('.testimonial-slider').owlCarousel({
      loop:true,
      margin:30,
      nav:false,
      dots:false,
      autoplay: true,
      slideTransition: 'linear',
      autoplayTimeout: 10000,
      autoplaySpeed: 10000,
      autoplayHoverPause: true,
      responsive:{
          0:{
              items:1
          },
          600:{
              items:1.2
          },
          1000:{
              items:1.2
          }
      }
   });
});




document.querySelectorAll('p:empty').forEach(p => p.remove());
